export class StackList<T> {
  private readonly list: T[];

  constructor(elements: T[] = []) {
    this.list = elements;
  }

  public get top(): T {
    return this.list[0];
  }

  public get length(): number {
    return this.list.length;
  }

  public append(element: T): void {
    this.list.unshift(element);
  }

  public forward(): T {
    return this.list.shift() as T;
  }

  public isEmpty(): boolean {
    return this.list.length === 0;
  }
}
